export const SYNC_START = 'syncStart'
export const SYNC_REQUEST_START = 'syncRequestStart'
export const SYNC_REQUEST_DONE = 'syncRequestDone'
export const SYNC_DONE = 'syncDone'
export const SYNC_FAIL = 'syncFail'



// WEBPACK FOOTER //
// ./src/Reducers/Sync/const.js